import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useConfig } from "../context/ConfigContext";
import { toast } from "sonner";
import { Save } from "lucide-react";

export default function Settings() {
  const { config, refresh } = useConfig();
  const [facts, setFacts] = useState(null);
  const [phases, setPhases] = useState([]);

  useEffect(() => { if (config) { setFacts(config.facts); setPhases(config.phases); } }, [config]);
  if (!facts) return <div className="text-[#94A3B8] font-mono2 text-sm">Loading…</div>;

  const saveFacts = async () => { await api.updateFacts(facts); await refresh(); toast.success("Campaign facts saved"); };
  const savePhases = async () => { await api.updatePhases(phases); await refresh(); toast.success("Phase boundaries saved"); };

  const F = ({ k, label, type = "text" }) => (
    <div>
      <label className="text-xs text-[#94A3B8]">{label}</label>
      <input type={type} value={facts[k] ?? ""} onChange={(e) => setFacts({ ...facts, [k]: type === "number" ? Number(e.target.value) : e.target.value })}
        className="w-full mt-1 px-3 py-2.5 rounded-lg bg-[#0A0C10] border border-[#2A3042] text-sm outline-none focus:border-[#D4AF37]" />
    </div>
  );

  return (
    <div className="space-y-8 max-w-4xl">
      <div><div className="eyebrow text-[#D4AF37]">Verify the facts</div><h1 className="font-display text-3xl sm:text-4xl mt-1">Campaign Facts</h1></div>

      <div className="card-lux p-6 grid sm:grid-cols-2 gap-4">
        <F k="title" label="Title" /><F k="destinations" label="Destinations" />
        <F k="dates" label="Dates (display)" /><F k="departure_date" label="Departure date (YYYY-MM-DD)" />
        <F k="nights" label="Nights" type="number" /><F k="price_from" label="Price from ($)" type="number" />
        <F k="deposit" label="Deposit ($)" type="number" /><F k="url" label="Campaign URL" />
        <div className="sm:col-span-2"><F k="airfare_note" label="Airfare note" /></div>
        <div className="sm:col-span-2"><F k="flight_note" label="Bangkok→Phuket flight note" /></div>
        <div className="sm:col-span-2">
          <button data-testid="save-facts-btn" onClick={saveFacts} className="gold-btn px-5 py-2.5 rounded-lg text-sm inline-flex items-center gap-2"><Save className="w-4 h-4" /> Save facts</button>
        </div>
      </div>

      <div>
        <h2 className="font-display text-2xl mb-3">Campaign phase boundaries</h2>
        <p className="text-sm text-[#94A3B8] mb-4">Days before departure. The Today engine changes strategy as the trip approaches.</p>
        <div className="card-lux p-6 space-y-3">
          {phases.map((p, i) => (
            <div key={p.key} className="grid grid-cols-12 gap-3 items-center" data-testid={`phase-${p.key}`}>
              <div className="col-span-5">
                <div className="text-[#F8FAFC] text-sm">Phase {p.key} · {p.name}</div>
                <div className="text-xs text-[#64748B]">{p.plain}</div>
              </div>
              <div className="col-span-3">
                <label className="text-[10px] text-[#64748B] uppercase">Min days</label>
                <input type="number" value={p.min_days} onChange={(e) => setPhases(phases.map((x, j) => j === i ? { ...x, min_days: Number(e.target.value) } : x))}
                  className="w-full mt-1 px-2 py-1.5 rounded bg-[#0A0C10] border border-[#2A3042] text-sm outline-none focus:border-[#D4AF37]" />
              </div>
              <div className="col-span-3">
                <label className="text-[10px] text-[#64748B] uppercase">Max days</label>
                <input type="number" value={p.max_days} onChange={(e) => setPhases(phases.map((x, j) => j === i ? { ...x, max_days: Number(e.target.value) } : x))}
                  className="w-full mt-1 px-2 py-1.5 rounded bg-[#0A0C10] border border-[#2A3042] text-sm outline-none focus:border-[#D4AF37]" />
              </div>
            </div>
          ))}
          <button data-testid="save-phases-btn" onClick={savePhases} className="gold-btn px-5 py-2.5 rounded-lg text-sm inline-flex items-center gap-2 mt-2"><Save className="w-4 h-4" /> Save phases</button>
        </div>
      </div>
    </div>
  );
}
